// base rc-mentions .6.2
import Mentions from './src/Mentions';
import Option from './src/Option';
export { Option };
export default Mentions;
